import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Philosophy } from "@/components/Philosophy";
import { Marquee } from "@/components/Marquee";
import { CoachERFeature } from "@/components/CoachERFeature";
import { Mission } from "@/components/Mission";
import { Founder } from "@/components/Founder";
import { ClosingCTA } from "@/components/ClosingCTA";
import { Footer } from "@/components/Footer";

export default function HomePage() {
  return (
    <main>
      <Navbar />
      <Hero />
      <Philosophy />
      <Marquee />
      <CoachERFeature />
      <Mission />
      <Founder />
      <ClosingCTA />
      <Footer />
    </main>
  );
}
